export default __webpack_public_path__ + "static/media/13.be0d4fa6.png";